import { ChangePlanContractMutation } from "@/generated/graphql_billing";
import { graphql, HttpResponse } from "msw";

// 契約内容を変更する
export const changePlanContractMutationHandler =
  graphql.mutation<ChangePlanContractMutation>(
    "changePlanContract",
    ({ query, variables }) => {
      return HttpResponse.json({
        data: {
          changePlanContract: {
            result: true,
          },
        },
      });
    }
  );
